import { render, staticRenderFns } from "./ParcelPayment.vue?vue&type=template&id=ff07d116&"
import script from "./ParcelPayment.vue?vue&type=script&lang=js&"
export * from "./ParcelPayment.vue?vue&type=script&lang=js&"
import style0 from "./ParcelPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports